export const en = {
  title: 'H3 video defaults',
  description: 'Default technical params sent to minimax-h3 for every video generation call (video_model.params). The planning agent never sets these — code always reads them from here. Value choices mirror the H3 Console (newtask.html) options, the actual combinations verified against the H3 service.',
  refresh: 'Refresh',
  notFound: 'No enabled H3 video model found. Run the migration or add one in Model capabilities first.',
  addParam: 'Add param',
  table: { key: 'Param', value: 'Value', type: 'Type', actions: 'Actions' },
  form: {
    addTitle: 'Add param',
    editTitle: 'Edit param',
    key: 'Param name',
    value: 'Value',
    selectPlaceholder: 'Select…',
    valueHint: 'No preset list for this param. Numbers and booleans are parsed as JSON (e.g. 1024, true); anything else is kept as a plain string.',
  },
  confirmDelete: 'Delete param "{key}"? This changes the default used by every new H3 video call.',
  errors: { resolutionRequired: 'Please pick a resolution preset.' },
}

export const zh = {
  title: 'H3 视频生成默认参数',
  description: '每次调用 minimax-h3 生成视频时使用的默认技术参数（video_model.params）。规划 agent 不会设置这些字段，代码统一从这里读。取值选项照抄 H3 Console（newtask.html）里暴露的那几档——都是在 H3 服务上实测验证过的合法组合。',
  refresh: '刷新',
  notFound: '没有找到已启用的 H3 视频模型，请先跑迁移或去「模型能力」新增一个。',
  addParam: '新增参数',
  table: { key: '参数名', value: '参数值', type: '类型', actions: '操作' },
  form: {
    addTitle: '新增参数',
    editTitle: '编辑参数',
    key: '参数名',
    value: '参数值',
    selectPlaceholder: '请选择',
    valueHint: '这个参数没有预设列表：数字和布尔值会按 JSON 解析（例如 1024、true）；其余原样存为字符串。',
  },
  confirmDelete: '删除参数「{key}」？这会改变之后每一次 H3 视频调用使用的默认值。',
  errors: { resolutionRequired: '请选择一个分辨率预设。' },
}
